export const getHubAndTierFromApiName = apiName => {
  const hub = apiName === null || apiName === void 0 ? void 0 : apiName.split('-')[0];
  const tier = apiName === null || apiName === void 0 ? void 0 : apiName.split('-')[2];
  return {
    hub: hub === 'crm' ? 'suite' : hub,
    tier: !tier && hub === 'hubspot' ? 'free' : tier // free tools api name has no tier
  };
};